import { inject, Injectable } from '@angular/core';
import { DealsService } from './deals.service';
import { finalize } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ProductLineCode } from '../models/product-line-code.enum';
import { downloadFile } from '../utils/file-download.util';

@Injectable({
  providedIn: 'root',
})
export class DealsExportService {
  private dealsService = inject(DealsService);

  exportDeals(
    productLineCode?: ProductLineCode,
    setLoadingState?: (isLoading: boolean) => void,
    onSuccess?: (blob: Blob) => void,
    onError?: (error: HttpErrorResponse) => void,
  ): void {
    if (setLoadingState) {
      setLoadingState(true);
    }

    this.dealsService
      .export(productLineCode)
      .pipe(
        finalize(() => {
          if (setLoadingState) {
            setLoadingState(false);
          }
        }),
      )
      .subscribe({
        next: (blob: Blob) => {
          downloadFile(blob, 'export.csv');
          if (onSuccess) {
            onSuccess(blob);
          }
        },
        error: (error: HttpErrorResponse) => {
          if (onError) {
            onError(error);
          }
        },
      });
  }
}
